export const screen = {
    conference: {
        breakoutRooms: 'Breakout Rooms',
        carmode: 'Car Mode',
        chat: 'Chat',
        chatandpolls: {
            main: 'Chat and Polls',
            tab: {
                chat: 'Chat',
                polls: 'Polls'
            }
        },
        container: 'Conference container',
        gifsMenu: 'GIPHY',
        invite: 'Invite',
        liveStream: 'Live stream',
        main: 'Conference',
        participants: 'Participants',
        root: 'Conference root',
        recording: 'Recording',
        salesforce: 'Link to Salesforce',
        security: 'Security Options',
        sharedDocument: 'Shared document',
        speakerStats: 'Speaker Stats',
        subtitles: 'Subtitles',
        whiteboard: 'Whiteboard'
    },
    connecting: 'Connecting',
    dialInSummary: 'Dial-In Info',
    preJoin: 'Pre-Join',
    lobby: {
        chat: 'Lobby chat',
        main: 'Lobby',
        root: 'Lobby root'
    },
    settings: {
        language: 'Language',
        links: {
            help: 'Help',
            privacy: 'Privacy',
            terms: 'Terms'
        },
        main: 'Settings',
        profile: 'Profile'
    },
    unsafeRoomWarning: 'Unsafe Room Warning',
    welcome: {
        main: 'Welcome',
        tabs: {
            calendar: 'Calendar',
            recent: 'Recent'
        }
    }
};
